import React, { useEffect, useState } from "react";
import { Table, Button } from "reactstrap";
import { config } from "../utils/config";
import KEYS from "../env/env";
import { doRequest, isNewFont } from "../utils/helper";
import Sidebar from "../components/Sidebar";
import SearchHeader from "../components/SearchHeader";
import AdminFooter from "../components/AdminFooter";
// import secureLocalStorage from "react-secure-storage";
import {
  DndContext,
  closestCenter,
} from "@dnd-kit/core";

import {
  SortableContext,
  useSortable,
  arrayMove,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";

import { CSS } from "@dnd-kit/utilities";

function SortableRow({ font, children }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: font.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <tr ref={setNodeRef} style={style}>
      <td
        {...attributes}
        {...listeners}
        style={{
          cursor: "grab",
          width: "40px",
          textAlign: "center",
          fontSize: "18px",
        }}
      >
        ☰
      </td>

      {children}
    </tr>
  );
}


export default function FontsDashboard() {
  const [list, setList] = useState([]);
  const [filterList, setFilterList] = useState([]);
  const [search, setSearch] = useState("");


  const handleFontChange = async (e) => {
    const selectedFiles = e.target.files;

    if (!selectedFiles.length) {
      alert("Please select at least one font file.");
      return;
    }

    try {
      const user = localStorage.getItem(config.USER_LOGIN_DETAILS);
      if (!user || user === "undefined") {
        alert("Please login to upload fonts");
        return;
      }

      const userLogin = JSON.parse(user);
      const fontdata = new FormData();

      // ✅ Append each selected file
      for (let i = 0; i < selectedFiles.length; i++) {
        fontdata.append("file", selectedFiles[i]);
      }

      // fontdata.append("uploaded_by", userLogin?.id);

      // const token = secureLocalStorage.getItem("Login");
      const token = localStorage.getItem("Login"); 

      const requestOptions = {
        method: "POST",
        body: fontdata,
        headers: {
          Authorization: `Bearer ${token}`,
          // ✅ Don't set Content-Type — let browser do it
        },
      };

      const res = await fetch(`${KEYS.apiPath}font/save`, requestOptions);
      const response = await res.json();

      if (response?.resultFlag === 1) {
        getfontsList()
        alert(response?.message || "Fonts uploaded successfully!");
      } else {
        alert(response?.message || "Something went wrong!");
      }
    } catch (error) {
      console.error("Upload Error:", error);
      alert(error?.message || "Something went wrong!");
    }
  };

  const getfontsList = async () => {
    try {
      const response = await doRequest("", "GET", "font/list");
      if (+response?.resultFlag === 1) {
        let fonts = response?.response?.font || [];

        const sortedFonts = fonts.sort((a, b) => {
          const aIsNew = isNewFont(a.created_at);
          const bIsNew = isNewFont(b.created_at);
        
          if (aIsNew && !bIsNew) return -1;
          if (!aIsNew && bIsNew) return 1;
        
          return a.sequence - b.sequence;
        });
        
        setList(sortedFonts);
        setFilterList(sortedFonts);
        
        loadFonts(fonts);
      } else {
        alert(response?.message ? response?.message : "Something went wrong");
      }
    } catch (error) {
      alert(error?.message ? error?.message : "Something went wrong!");
    }
  };
  const searchValChangeHandler = (val) => {
    setSearch(val);

    let filtered = list?.filter((i) =>
      i?.name?.toLowerCase().includes(val?.toLowerCase())
    );
    setFilterList(filtered);
  };

  const deleteFontHandler = async (id) => {
    try {
      let data = {
        id,
      };
      let response = await doRequest(data, "POST", "font/delete");
      if (+response?.resultFlag === 1) {
        alert("font deleted");
        let arr = filterList.filter((i) => i.id != id);
        setFilterList(arr);
      }
    } catch (error) {}
  };
  useEffect(() => {
    getfontsList();
  }, []);

  const loadFonts = (fonts) => {
    const styleSheet = document.styleSheets[0];

    fonts.forEach((font) => {
      const fontFace = new FontFace(
        font.name,
        `url(${font.url})`
        // `url(${config.FONT_BASE_URL}${font.url})`
      );
      fontFace
        .load()
        .then((loadedFontFace) => {
          document.fonts.add(loadedFontFace);

          const rule = `
          @font-face {
            font-family: '${font.name}';
            src: url(${font.url});
          }
        `;

          if (styleSheet.insertRule) {
            styleSheet.insertRule(rule, styleSheet.cssRules.length);
          } else if (styleSheet.addRule) {
            styleSheet.addRule(`@font-face`, rule, -1);
          }
        })
        .catch((error) => {
          console.error(`Failed to load font: ${font.name}`, error);
        });
    });
  };

  const updateFontSeq = async (fonts) => {
    const payload = {
      data: fonts.map(f => ({
        id: f.id,
        seq: f.sequence,
      })),
    };
  
    await doRequest(payload, "POST", "font/update");
  };
  
  const handleDragEnd = async (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;
  
    setFilterList((items) => {
      const oldIndex = items.findIndex(i => i.id === active.id);
      const newIndex = items.findIndex(i => i.id === over.id);
  
      const reordered = arrayMove(items, oldIndex, newIndex)
        .map((item, index) => ({
          ...item,
          sequence: index + 1,
        }));
  
      updateFontSeq(reordered);
      return reordered;
    });
  };
  

  return (
    <>
      <div className="container-fluid main">
        <Sidebar />

        <section className="home">
          <div className="container-fluid">
            <div className="searcmain_pad">
              <SearchHeader
                placeHolder={"Search Font.."}
                search={search}
                onChangeHandler={searchValChangeHandler}
              />

              <ul className="font_updlist">
                <li>
                  <h4>Fonts</h4>
                </li>
                <li>
                  <Button>
                    <input
                      multiple
                      type="file"
                      onChange={handleFontChange}
                      id="imageInput2"
                      accept=".ttf,.otf,.woff,.woff2"
                    />
                    <img src={"/assets/images/addfont.svg"} alt="" /> Add Fonts
                  </Button>
                </li>
              </ul>
              <div className="font_upd_div"></div>

              <div className="table-responsive table_user_mar">
                <Table hover striped className="table_cust align-middle">
                  <thead className="thead_bg">
                  <th className="userth" style={{ width: "40px" }}></th>
                    <th className="userth">Position</th>
                    <th className="userth">Font Name</th>
                    <th className="userth" style={{ width: "30%" }}>
                      Preview
                    </th>
                    <th className="userth">Status</th>
                    <th className="userth">Actions</th>
                  </thead>


                  <DndContext
                    collisionDetection={closestCenter}
                    onDragEnd={handleDragEnd}
                  >
                    <SortableContext
                      items={filterList.map((f) => f.id)}
                      strategy={verticalListSortingStrategy}
                    >
                      <tbody>
                        {filterList.map((font) => (
                          <SortableRow key={font.id} font={font}>
                            <td>{font.sequence}</td>

                            <td>
                              {/* <div className="font-name-row"> */}
                                <span>{font.name}</span>
                                {isNewFont(font.created_at) && (
                                  <span className="new-font-label">NEW</span>
                                )}
                              {/* </div> */}
                            </td>

                            <td style={{ fontFamily: font.name }}>
                              {font.name}
                            </td>

                            <td>
                              <h6 className="enable_t">{font.status}</h6>
                            </td>

                            <td>
                              <div className="viewProf_flex">
                                <Button
                                  onClick={() => deleteFontHandler(font.id)}
                                  className="del_user"
                                >
                                  <img
                                    src={"/assets/images/delred.svg"}
                                    className="healeyeblue"
                                    alt=""
                                  />
                                  <img
                                    src={"/assets/images/delwhite.svg"}
                                    className="healeyewhite"
                                    alt=""
                                  />
                                  Delete
                                </Button>
                              </div>
                            </td>
                          </SortableRow>
                        ))}
                      </tbody>
                    </SortableContext>
                  </DndContext>

                </Table>
              </div>
            </div>
          </div>
        </section>
      </div>
      <AdminFooter />
    </>
  );
}
